/**
 * Enumeration containing identifiers for different notification groups
 * @description
 * This enumeration defines the unique identifiers for each notification group
 * in the system. These IDs are used to categorize different types of notifications
 * and organize them for display and management purposes.
 */

export enum NotificationGroupId {
  /*
   * Main inbox notifications group
   * @type {number}
   * @description
   * Represents the primary inbox where general notifications are stored
   */
  Inbox = 1,
  /**
   * Copy notifications group
   * @type {number}
   * @description
   * Represents notifications related to copy trading activities and updates
   */
  Copy = 2,
  /**
   * Commissions notifications group
   * @type {number}
   * @description
   * Represents notifications related to commission earnings and payouts
   */
  Comissions = 3,
}
